import { type CanonicalSchema, deepFreeze, CanonicalFieldType as T } from './canonical-schema.js'

/**
 * `product@1` — owned by the product bounded context (product-service).
 * Fields per TO-404 BR-4; the localized ones are named `<field>.<locale>`
 * (one translation per locale). `benefits` holds one benefit per line.
 * APPEND-ONLY: never edit this published version; publish `product.v2.ts`.
 */
export const PRODUCT_V1: CanonicalSchema = deepFreeze({
	name: 'product',
	version: 1,
	owner: 'product',
	fields: [
		{ name: 'code', type: T.STRING, required: true, nullable: false, maxLength: 64 },
		{ name: 'defaultLocale', type: T.STRING, required: true, nullable: false, maxLength: 35 },
		{ name: 'categoryCode', type: T.STRING, required: false, nullable: true, maxLength: 64 },
		{ name: 'ctaPrimaryType', type: T.STRING, required: false, nullable: true, maxLength: 32 },
		{ name: 'ctaPrimaryTarget', type: T.STRING, required: false, nullable: true, maxLength: 2048 },
		{ name: 'ctaSecondaryType', type: T.STRING, required: false, nullable: true, maxLength: 32 },
		{ name: 'ctaSecondaryTarget', type: T.STRING, required: false, nullable: true, maxLength: 2048 },
		{ name: 'name', type: T.STRING, required: true, nullable: false, maxLength: 255, localized: true },
		{ name: 'tagline', type: T.STRING, required: false, nullable: true, maxLength: 255, localized: true },
		{ name: 'shortDescription', type: T.STRING, required: false, nullable: true, maxLength: 500, localized: true },
		{ name: 'longDescription', type: T.STRING, required: false, nullable: true, maxLength: 10000, localized: true },
		{ name: 'benefits', type: T.STRING, required: false, nullable: true, maxLength: 5140, localized: true },
		{ name: 'mainCtaLabel', type: T.STRING, required: false, nullable: true, maxLength: 80, localized: true },
		{ name: 'secondaryCtaLabel', type: T.STRING, required: false, nullable: true, maxLength: 80, localized: true },
	],
})
